<template>
	<div class="page-wrapper" id="app">
		<NavigationComponent />
		<div class="main">
			<transition name="fade" mode="out-in">
				<router-view />
			</transition>
			<div @click="toggleNavigation" class="main-handler"></div>
		</div>
	</div>
</template>

<script>
import NavigationComponent from "@/views/Private/Components/Navigation"
import { mapState } from 'vuex'

export default {
	name: "PrivateLayout",
	components: {
		NavigationComponent
	},
	computed: {
        ...mapState(['showNavigation'])
	},
	methods: {
		toggleNavigation () {
			this.$store.dispatch('setNavigation', !this.showNavigation)
		}
	}
}
</script>
